import { Component, Input } from '@angular/core';
import { ListComponent } from '@legacy/common-ui-utility-components';
import { NgClass } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';

import type { FooterAccordion } from './multiple-links-list.model';

@Component({
  selector: 'wl-multiple-links-list',
  templateUrl: './multiple-links-list.component.html',
  styleUrls: [
    './multiple-links-list.component.essent.scss',
    './multiple-links-list.component.ed.scss',
  ],
  standalone: true,
  imports: [ListComponent, NgClass, FaIconComponent, NgbCollapse],
})
export class MultipleLinksListComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() accordions?: FooterAccordion[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() collapsible?: boolean;

  trackByItems(index: number, item: FooterAccordion): string {
    return item.title || `${index}`;
  }
}
